import React from 'react';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { ExtendedInfoStateIndicator } from '../ExtendedInfo';
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Heading, HeadingHierarchy } from '../Heading/Heading';
import { Modifier } from '../../../lib/bemUtils/Modifier';

type ContentHeadline = {
  title: string;
  headingId?: string;
  url?: string;
  stateIndicatorStatus?: 'red' | 'green';
  stateIndicatorHelpText?: string;
  hierarchy?: HeadingHierarchy;
  modifier?: Modifier<'small' | 'large' | 'top-headline' | 'top-headline-primary' | 'no-margin-bottom'>;
};

/**
 * Headline Component which shows the status of a page with a colored Icon.
 * */
export function ContentHeadline({
  headingId,
  modifier,
  url,
  title,
  stateIndicatorStatus,
  stateIndicatorHelpText,
  hierarchy = 3,
}: ContentHeadline) {
  if (!title) {
    return null;
  }

  return (
    <div className="content-headline__wrapper">
      {stateIndicatorStatus && (
        <span className="content-headline__extended-info-left">
          <ExtendedInfoStateIndicator
            helpText={stateIndicatorHelpText}
            tooltipPlacement={TooltipPlacement.TOP}
            stateIndicatorStatus={stateIndicatorStatus}
          />
        </span>
      )}
      <Heading
        hierarchy={hierarchy}
        id={headingId}
        className={extendClassNameWithModifier('content-headline', modifier)}
      >
        {url
          ? (
              <Hyperlink to={url} className="content-headline__link">
                {title}
              </Hyperlink>
            )
          : (
              <>{title}</>
            )}
      </Heading>
    </div>
  );
}
